import { useEffect } from "react";

const POLL_INTERVAL_MS = 5000;

export default function usePollingRefresh(
  shouldPoll: boolean,
  refresh: () => void,
) {
  useEffect(() => {
    if (shouldPoll) {
      const timer = setInterval(refresh, POLL_INTERVAL_MS);
      return () => clearInterval(timer);
    }
  }, [shouldPoll, refresh]);
}
